
export const FIELDS_NAMES_RECURSO = {
  ORGANIZACION: 'organizacion_id',
  REGIONALES: 'regionales',
  EMPRESAS: 'empresas',
  TIPO: 'tipo_id',
  NOMBRE: 'nombre',
  DESCRIPCION: 'descripcion',
  ORDEN: 'orden',
  URL: 'url',
  ACTIVO: 'activo',
  ARCHIVOS: 'archivos',
} as const

export const FIELDS_STEP_1 = [FIELDS_NAMES_RECURSO.EMPRESAS]

export const FIELDS_STEP_2 = [
  FIELDS_NAMES_RECURSO.TIPO,
  FIELDS_NAMES_RECURSO.ARCHIVOS,
]

export const FIELDS_EDICION = [
  FIELDS_NAMES_RECURSO.TIPO,
  FIELDS_NAMES_RECURSO.NOMBRE,
  FIELDS_NAMES_RECURSO.ARCHIVOS,
  FIELDS_NAMES_RECURSO.ORDEN,
]
